import { ITimeSlotFieldConfigurationClient, ITimeSlotFieldConfigurationServer } from "./interface";


export const transformTimeSlotFieldConfigClientToServer = (
    fieldConfigClient: ITimeSlotFieldConfigurationClient
  ): ITimeSlotFieldConfigurationServer => {
  
    const { slotDuration, slotSetting, dateReferralFieldId} = fieldConfigClient;
    const fieldConfigServer = {
      slotDuration: slotDuration,
      slotSetting: slotSetting,
      dateReferralFieldId: dateReferralFieldId,
    };
    return fieldConfigServer;
  };

  
export const transformTimeSlotFieldConfigServerToClient = (
    fieldConfigServer: ITimeSlotFieldConfigurationServer
  ): ITimeSlotFieldConfigurationClient => {
    const { slotDuration, slotSetting, dateReferralFieldId } = fieldConfigServer;
    const fieldConfigClient = {
      slotDuration: slotDuration,
      slotSetting: slotSetting,
      dateReferralFieldId: dateReferralFieldId,
    };
    return fieldConfigClient;
  };
  